import { render } from "./App.vue?vue&type=template&id=44c36802"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raunix/Desktop/project/gojek 2023/web/1.2.50/1.2.50/New Owners/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__